import { Origin } from './BotConsts'

export const HMOIntentOptions = {
  MENTAL: Origin.MENTAL,
  PRIMARY: Origin.PRIMARY,
  HTN: Origin.HTN,
  DIABETES: Origin.DIABETES,
  MENTAL_KIDS: Origin.MENTAL_KIDS,
  PEDIATRICK: Origin.PEDIATRICK,
  PRESCRIPTIONS: 'Prescriptions',
  WELLNESS_VISIT: 'Wellness',
  REFERRALS: 'Referrals',
  MEDICAL_NOTE: 'MedicalNote'
}
